import React from "react";
import { monthConverter } from "utils/common";
import { formatParasite } from "utils/parasite";

const TableComponent = ({
  reportsData,
  tableRef,
  reportInfo,
  currentLevel,
}) => {
  let levelName = "";
  let header = [],
    content = [];

  if (currentLevel === "national") {
    header.push("Nama Provinsi");
    header.push("Nama Kabupaten/Kota");
    content.push("province_name");
    content.push("district_name");
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    header.push("Nama Kabupaten/Kota");
    content.push("district_name");
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    header.push("Nama Fasyankes");
    header.push("Desa Wilker");
    content.push("fasyankes_name");
    content.push("urbanvillage_id");
    levelName = "Kabupaten/Kota";
  } else {
    header.push("Desa Wilker");
    content.push("urbanvillage_id");
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-responsive"
      style={{ backgroundColor: "#fff" }}
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingBottom: 0 }}>
            <h3>
              Rekap Laporan Konfirmasi PCR untuk {formatParasite("P. Knowlesi")}
            </h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {periodeName === "Bulanan" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th>No</th>
            {header.map((item, index) => (
              <th key={index + 100}>{item}</th>
            ))}
            <th>Jumlah Probable Pk</th>
            <th>
              Jumlah Sediaan Apusan Darah (SAD) yang Dikirim Untuk Konfirmasi
            </th>
            <th>Jumlah Sediaan Apusan Darah (SAD) Diterima</th>
            <th>Jumlah Dried Blood Spot (DBS) yang Dikirim Untuk Konfirmasi</th>
            <th>Jumlah Dried Blood Spot (DBS) Diterima</th>
            <th>
              Jumlah Whole Blood EDTA (WB) yang Dikirim Untuk Konfirmasi
            </th>
            <th>Jumlah Whole Blood EDTA (WB) Diterima</th>
            <th>
              Jumlah Sediaan Apusan Darah (SAD) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>
              Jumlah Dried Blood Spot (DBS) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>
              Jumlah Whole Blood EDTA (WB) yang Memenuhi Syarat untuk Dapat
              Diperiksa PCR
            </th>
            <th>Jumlah Probable Pk yang dikonfirmasi PCR (Negatif)</th>
            <th>Jumlah Probable Pk yang dikonfirmasi PCR (Positif)</th>
            {/* <th>Jumlah Probable Pk yang dikonfirmasi PCR (Menunggu Hasil)</th> */}
          </tr>
        </thead>
        <tbody>
          {reportsData?.length > 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {content.map((col, i) => (
                  <td key={i + 100}>
                    {col === "urbanvillage_id"
                      ? item?.[col]?.split("|")[1]
                      : item?.[col]}
                  </td>
                ))}
                <td>{item?.jml_pk}</td>
                <td>{item?.jml_sad_send}</td>
                <td>{item?.jml_sad_received}</td>
                <td>{item?.jml_dbs_send}</td>
                <td>{item?.jml_dbs_received}</td>
                <td>{item?.jml_wb_send}</td>
                <td>{item?.jml_wb_received}</td>
                <td>{item?.jml_sad_pcr}</td>
                <td>{item?.jml_dbs_pcr}</td>
                <td>{item?.jml_wb_pcr}</td>
                <td>{item?.jml_neg}</td>
                <td>{item?.jml_pos}</td>
                {/* <td>{item?.jml_wait}</td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={73}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
